/*
  Biggest Week in Wine — which day of the row is open, settled in Sydney time.

  The section is rendered against the store's clock, which is right for most
  readers most of the time and is all a reader without JavaScript ever gets.
  This pass takes the date in the zone the section names — by name, so daylight
  saving is the browser's problem and not a number kept in a setting — and puts
  each card into one of three states:

    open    a day that has already come round, still shoppable
    today   the day being revealed now, lit up
    locked  a day that has not arrived, with nowhere to go

  Dates are compared as YYYY-MM-DD text, which sorts chronologically on its own,
  so no date is ever parsed into a moment and no hour of the day comes into it.

  The row is looked at again every minute. That is not for the sake of the
  clock ticking — it is for the reader who leaves the page open across midnight,
  and for the page that came out of the CDN cache with yesterday's answer in it.
*/
(function () {
  const MINUTE = 60000;

  // en-CA gives YYYY-MM-DD, which is the format the cards carry and the one
  // that can be compared as plain text.
  function today(timezone) {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (e) {
      // A zone the browser will not take — mistyped in the theme editor, or an
      // engine without the full set. The row keeps whatever Liquid worked out.
      return null;
    }
  }

  function stateOf(card, now) {
    if (card.dataset.alwaysOpen === 'true') return 'open';

    const date = card.dataset.date;
    if (!date) return 'open';

    if (date === now) return 'today';
    return date < now ? 'open' : 'locked';
  }

  function apply(card, state) {
    const pill = card.querySelector('[data-bww-pill]');

    if (card.dataset.state !== state) card.dataset.state = state;
    if (!pill) return;

    const label =
      state === 'today'
        ? pill.dataset.labelToday || pill.dataset.labelOpen
        : state === 'open'
          ? pill.dataset.labelOpen || pill.dataset.labelLocked
          : pill.dataset.labelLocked;

    if (label && pill.textContent !== label) pill.textContent = label;

    // The address is held on the element either way; only whether it is a link
    // changes. An anchor with no href is not focusable, which is the whole of
    // what "locked" has to mean to a keyboard.
    const href = pill.dataset.href;
    if (state !== 'locked' && href) {
      if (pill.getAttribute('href') !== href) pill.setAttribute('href', href);
    } else if (pill.hasAttribute('href')) {
      pill.removeAttribute('href');
    }
  }

  function settle(section) {
    const now = today(section.dataset.timezone || 'Australia/Sydney');
    if (!now) return;

    section.querySelectorAll('[data-bww-day]').forEach(function (card) {
      apply(card, stateOf(card, now));
    });
  }

  function settleAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-bww-days]').forEach(settle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      settleAll(document);
    });
  } else {
    settleAll(document);
  }

  setInterval(function () {
    settleAll(document);
  }, MINUTE);

  // A tab left in the background for hours is where a stale row shows itself
  // first, so it is settled the moment it is looked at again.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) settleAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    settleAll(event.target);
  });
})();
